import React from "react";
import Select from "react-select";
import styles from "./drop-down-input.module.css";

const DropDownInput = ({
  options,
  onChange,
  name,
  value,
  label,
  placeholder,
  labelStyles,
  selectStyles,
}) => {
  return (
    <div className="form-group">
      <label
        style={{ ...labelStyles }}
        className={styles.inputLabel}
        htmlFor={name}
      >
        {label}
      </label>
      <Select
        placeholder={placeholder}
        name={name}
        onChange={onChange}
        options={options}
      />
      {/* <select
        onChange={onChange}
        name={name}
        id={name}
        className={`form-control ${styles.selectItem}`}
        placeholder={placeholder}
        style={{ ...selectStyles }}
        value={value}
      >
        <option value="" disabled hidden>
          {placeholder}
        </option>
        {options.map((option, index) => (
          <option
            key={index}
            className={styles.selectItem}
            style={{ backgroundColor: "rebeccapurple", padding: "3rem" }}
          >
            {option.charAt(0).toUpperCase() + option.slice(1)}
          </option>
        ))}
      </select> */}
    </div>
  );
};

export default DropDownInput;
